/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Notifications_Simple_Unsubscribedfrom1Inputs */

const id_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Berhenti berlangganan dari ${i?.name}`)
};

const ms_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Berhenti langgan daripada ${i?.name}`)
};

const da_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Afmeldt fra ${i?.name}`)
};

const de_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Von ${i?.name} abgemeldet`)
};

const en_us2_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unsubscribed from ${i?.name}`)
};

const es_es2_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Desuscrito de ${i?.name}`)
};

const es_mx2_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Suscripción cancelada de ${i?.name}`)
};

const fil_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nag-unsubscribe mula sa ${i?.name}`)
};

const fr_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Désabonné de ${i?.name}`)
};

const it_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Annullata iscrizione da ${i?.name}`)
};

const hu_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Leiratkozva: ${i?.name}`)
};

const nl_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uitgeschreven van ${i?.name}`)
};

const no_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Avmeldt fra ${i?.name}`)
};

const pl_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wypisano z ${i?.name}`)
};

const pt_br2_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unsubscribed from ${i?.name}`)
};

const pt_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subscrição cancelada de ${i?.name}`)
};

const ro_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dezabonat de la ${i?.name}`)
};

const fi_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tilaus peruutettu aiheesta ${i?.name}`)
};

const sv_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prenumeration avslutad för ${i?.name}`)
};

const vi_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã hủy đăng ký ${i?.name}`)
};

const tr_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} aboneliği iptal edildi`)
};

const cs_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Odhlášeno od ${i?.name}`)
};

const bg_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Отписан от ${i?.name}`)
};

const ru_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Отписан от ${i?.name}`)
};

const uk_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Відписано від ${i?.name}`)
};

const ar_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ألغيت الاشتراك من ${i?.name}`)
};

const hi_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} से सब्सक्रिप्शन रद्द किया`)
};

const th_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ยกเลิกการสมัคร ${i?.name} แล้ว`)
};

const ja_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} の購読を解除しました`)
};

const zh_cn2_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unsubscribed from ${i?.name}`)
};

const zh_hant1_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unsubscribed from ${i?.name}`)
};

const ko_notifications_simple_unsubscribedfrom1 = /** @type {(inputs: Notifications_Simple_Unsubscribedfrom1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unsubscribed from ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Unsubscribed from {name}" |
*
* @param {Notifications_Simple_Unsubscribedfrom1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_simple_unsubscribedfrom1 = /** @type {((inputs: Notifications_Simple_Unsubscribedfrom1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Simple_Unsubscribedfrom1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "ms") return ms_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "da") return da_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "de") return de_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "en-US") return en_us2_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "es-ES") return es_es2_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "fil") return fil_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "fr") return fr_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "it") return it_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "hu") return hu_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "nl") return nl_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "no") return no_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "pl") return pl_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "pt") return pt_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "ro") return ro_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "fi") return fi_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "sv") return sv_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "vi") return vi_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "tr") return tr_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "cs") return cs_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "bg") return bg_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "ru") return ru_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "uk") return uk_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "ar") return ar_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "hi") return hi_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "th") return th_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "ja") return ja_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_simple_unsubscribedfrom1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_simple_unsubscribedfrom1(inputs)
	return ko_notifications_simple_unsubscribedfrom1(inputs)
});
export { notifications_simple_unsubscribedfrom1 as "notifications.simple.unsubscribedFrom" }